module.exports = __webpack_public_path__ + "files/e81b1673b4c351966432e46583e93e58.png";